import { ConfigurationService } from '@/common/services/configuration/configuration.service';
import { SsrService } from '@/common/services/ssr/ssr.service';
import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fe-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class FooterComponent {
    constructor(
        public readonly configuration: ConfigurationService,
        public ssr: SsrService,
    ) {}
}
